<div class="header">
  {{ 'app.evaluation_tab.summary_details.skills_tooltip_title' | translate }}
</div>

@for (row of rows(); track row.labelKey) {
  <div class="row">
    <span class="marker" [style.background-color]="row.color"></span>
    <span class="label">{{ row.labelKey | translate }}</span>
    <span
      class="value"
      [innerHTML]="
        'app.evaluation_tab.summary_details.skills_count' | translate: { count: row.count }
      "
    ></span>
  </div>
}
